import { fetchEndpoint } from "../network";

/**
 * 内容管理 - 晨视频报管理
 */

export default {
  register(params) {
    return fetchEndpoint("/mediaAccount/insert", "POST", params);
  },
  // 列表
  list(params) {
    return fetchEndpoint("/create-platform/mediaAccount/list", "GET", params);
  },
  //锁定
  lock(params) {
    return fetchEndpoint(
      "/create-platform/content/article/lock",
      "GET",
      params
    );
  },
  // 创建
  create(params) {
    return fetchEndpoint(
      "/create-platform/mediaAccount/insert",
      "POST",
      params
    );
  },

  // 详情
  detail(params) {
    return fetchEndpoint("/create-platform/mediaAccount/detail", "GET", params);
  },

  // 修改
  update(params) {
    return fetchEndpoint(
      "/create-platform/mediaAccount/update",
      "POST",
      params
    );
  },

  // 删除
  remove(params) {
    return fetchEndpoint(
      "/create-platform/mediaAccount/delete",
      "POST",
      params
    );
  },

  // 提交审核
  examine(params) {
    return fetchEndpoint(
      "/create-platform/mediaAccount/examine",
      "POST",
      params
    );
  },

  // 冻结
  frozen(params) {
    return fetchEndpoint(
      "/create-platform/mediaAccount/frozen",
      "POST",
      params
    );
  },

  // 解冻
  unfrozen(params) {
    return fetchEndpoint(
      "/create-platform/mediaAccount/unfrozen",
      "POST",
      params
    );
  },

  // 批量创建
  batchCreate(params) {
    return fetchEndpoint(
      "/create-platform/mediaAccount/operate/batch",
      "POST",
      params
    );
  },

  // 批量操作，删除，解冻，冻结
  updateBatch(params) {
    return fetchEndpoint(
      "/create-platform/mediaAccount/updateBatch",
      "POST",
      params
    );
  },

  // 媒体号互动置顶列表
  interactiveTopList(params) {
    return fetchEndpoint(
      "/create-platform/indexItem/commentList",
      "get",
      params
    );
  },
  // 媒体号互动列表
  interactiveList(params) {
    return fetchEndpoint("/create-platform/comment/topAll", "get", params);
  },
  // 置顶
  interactiveTop(params) {
    return fetchEndpoint("/create-platform/contentTop/addTop", "get", params);
  },

  // 互动列表取消置顶
  interactiveUnTop(params) {
    return fetchEndpoint(
      "/create-platform/indexItem/delectItem",
      "get",
      params
    );
  },

  // 置顶排序
  updateRelation(params) {
    return fetchEndpoint(
      "/create-platform/contentTop/updateBatch",
      "POST",
      params
    );
  },

  // 媒体号内容列表
  mediaContent(params) {
    return fetchEndpoint(
      "/create-platform/mediaAccount/mediaContent",
      "GET",
      params
    );
  },
  // 媒体号置顶内容列表
  mediaContentTopList(params) {
    return fetchEndpoint("/create-platform/contentTop/topList", "GET", params);
  },
  // 媒体号内容置顶
  mediaContentTopList(params) {
    return fetchEndpoint("/create-platform/contentTop/addTop", "GET", params);
  },
  // 媒体号内容取消置顶
  mediaContentUnTopList(params) {
    return fetchEndpoint(
      "/create-platform/contentTop/cancelTop",
      "GET",
      params
    );
  },
  // 媒体号内容置顶排序
  mediaContentSort(params) {
    return fetchEndpoint(
      "/create-platform/contentTop/updateBatch",
      "POST",
      params
    );
  },

  // 媒体号添加运营人员
  mediaUserAdd(params) {
    return fetchEndpoint(
      "/create-platform/mediaAccount/addRelation",
      "GET",
      params
    );
  },
  // 媒体号删除运营人员
  mediaUserdelete(params) {
    return fetchEndpoint(
      "/create-platform/mediaAccount/deleteRelation",
      "POST",
      params
    );
  },
  // 媒体号运营人员列表
  mediaUserList(params) {
    return fetchEndpoint(
      "/create-platform/mediaAccount/operateList",
      "GET",
      params
    );
  },
  // 媒体号运营人员编辑
  mediaUserUpdate(params) {
    return fetchEndpoint(
      "/create-platform/mediaAccount/adminUpdate",
      "POST",
      params
    );
  },
  //媒体号选择运营人员列表
  mediaUserSelectList(params) {
    return fetchEndpoint(
      "/create-platform/mediaAccount/selectOperateList",
      "GET",
      params
    );
  },
  //媒体号选择运营人员创建
  insertOperate(params) {
    return fetchEndpoint(
      "/create-platform/admin/insertOperate",
      "POST",
      params
    );
  },
};
